// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home .activate-popup .title[data-v-dc122386],.home .verification-popup .title[data-v-dc122386]{height:40px;background-color:#007aff;line-height:40px;color:#fff}.home .activate-btn[data-v-dc122386],.home .card-info[data-v-dc122386]{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
